import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import BannerLayout from '../../../layouts/banner';

import { getRequest } from '../../../../../../api/ApiService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange } from '../../../utils';

import {
  Table, Row, Cell
} from '../../../components/table';

import { getProductNameColor, getProductRowColor } from '../../../../../../api/PerformanceFeedback';

class MarketShareStep9 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      tableData: []
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, performanceFeedbacksGame } = this.props;

    getRequest(
      teamsEndpoint(),
    )
      .then(res => {
        const teamsMobileOverproduced = performanceFeedbacksGame.find(i => i.type === "Mobile overproduced");

        const teamsAutoOverproduced = performanceFeedbacksGame.find(i => i.type === "Auto overproduced");

        let teamsToShowIds = [];
        if ((teamsMobileOverproduced && teamsMobileOverproduced.teams) || (teamsAutoOverproduced && teamsAutoOverproduced.teams)) {
          teamsToShowIds = [
            ...(teamsMobileOverproduced && teamsMobileOverproduced.teams ? teamsMobileOverproduced.teams : []),
            ...(teamsAutoOverproduced && teamsAutoOverproduced.teams ? teamsAutoOverproduced.teams : [])
          ];
        }

        const teams = res.body;
        const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));
        const temporaryId = Auth.getTeamId();
        const team_id = teamsToShowIds.includes(temporaryId)
          ? temporaryId
          : teamsToShowIds[0];

        getRequest(
          `${process.env.REACT_APP_API_URL}v2/reports/performancefeedbacks/?round_number=${activeRound}&team=${team_id}`
        ).then(res => {
          const reportsPerformanceFeedback = res.body;
          const tableData = [];

          const hasMobileOverproduced = reportsPerformanceFeedback.results.some(item => item.type === "Mobile overproduced");
          const hasAutoOverproduced = reportsPerformanceFeedback.results.some(item => item.type === "Auto overproduced");

          if (hasMobileOverproduced) {
            const mobileData = reportsPerformanceFeedback.results.find(item => item.type === "Mobile overproduced");
            tableData.push(mobileData);
          }

          if (hasAutoOverproduced) {
            const autoData = reportsPerformanceFeedback.results.find(item => item.type === "Auto overproduced");
            tableData.push(autoData);
          }


          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            tableData
          })
        })
          .catch(err => { });
      })
      .catch(err => { });
  }

  render() {
    const { previousShownErrors } = this.props;
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      tableData
    } = this.state;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams inventory levels are high!`}
        paragraph2={(
          <Fragment>
            <p><span>Customers prefer lower concentration risk:</span> They prefer to limit how many units they’ll purchase from 1 single seller. Therefore teams shouldn’t expect to capture more than <b>15% of a customer segment (e.g. mobile or auto)</b>. However if there are irrational players in their competition, it’s possible to capture more than 20%.</p>
            <br />
            <p><span>Note:</span> When deciding on production, teams should factor in the overall demand from their target customers, taking into account concentration risk limits.</p>
          </ Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff">Segments</Cell>
              <Cell color="#ffffff">Available Inventory</Cell>
              <Cell color="#ffffff">Customer Demand</Cell>
              <Cell color="#ffffff">Inventory %<br /> of Demand</Cell>
            </Row>
            {tableData.map((item, index) => {
              const parsedItemMessage = JSON.parse(item.message);

              const availableForSale = parsedItemMessage.available_for_sale;
              const demand = parsedItemMessage.demand;
              const segment = parsedItemMessage.segment;
              const inventoryPercentageOfDemand = availableForSale / demand;
              return (
                <Row background={getProductRowColor(index)} key={index}>
                  <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{segment}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{availableForSale.toLocaleString()}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{demand.toLocaleString()}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{(inventoryPercentageOfDemand * 100).toFixed(2)}%</Cell>
                </Row>
              )
            })}
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default MarketShareStep9;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/market-share/step9.js